export const CONF2_ACCOUNT_TYPE = {
  // the U type should be producer
  // (U is for advanced User, a special generic role on LiveE for users with more permissions)
  Host: "U",
  // S type should be guest (S as Speaker)
  Speaker: "S",
  Viewer: "V"
} as const;
